<svelte:head>
	<link href="https://fonts.googleapis.com/css2?family=Varela+Round&amp;display=swap" rel="stylesheet">
</svelte:head>

<script>
	import { onMount } from 'svelte';
	import Covers from './Covers.svelte'
	import Header from './Header.svelte'
	import Footer from './Footer.svelte'
	import Loading from './Loading.svelte'
	import Recommendations from './Recommendations.svelte'
	import Navigation from './Navigation.svelte'
	export let name;
	let covers = []
	let shown = new Set()
	let recommendations = []
	let step = 1
	let numSteps = 5
	let done = false
	let loading = true

	onMount(async () => {
		const seeds = await getSeeds()
		setCovers(seeds)
		loading = false
	})

	async function getSeeds() {
		console.log(location.origin)
		const res = await fetch(`${location.origin}/api/v0/seeds`,{ 
			method: 'POST',
			headers: {
	      'Content-Type': 'application/json'
	    },
    	body: JSON.stringify({shown: Array.from(shown)})
		})
		const seeds = await res.json()
		for (let seed of seeds){
			shown.add(seed.id)
		}
		return seeds
	}

	async function getRecommendations(id) {
		console.log(id)
		const res = await fetch(`${location.href}/api/v0/recommendations`, {
			method: 'POST',
			headers: {
	      'Content-Type': 'application/json'
	      // 'Content-Type': 'application/x-www-form-urlencoded',
	    },
	    body: JSON.stringify({id})
		})
		const newRecommendations = await res.json()
		recommendations = [...recommendations, ...newRecommendations]
		console.log(recommendations)
	}

	function messageHandler(event) {
		switch (event.detail.type) {
			case "reload":
			if(done) {
				recommendations = shuffle(recommendations)
				
			} else {
				updateCovers(event.detail.id)
			}

			break;
		}
	}

	function setCovers(newCovers) {
		covers = newCovers
	}

	async function updateCovers(id=undefined) {
		loading = true
		if(step <= numSteps) {
			if(id) {
				await getRecommendations(id)
				step = step + 1
			}
			// console.log(recommendations)
			setCovers(await getSeeds())	
		} else {
			recommendations = shuffle(recommendations)
			done = true
		}
		loading = false
		
	}

	function shuffle(array) {
	  var currentIndex = array.length, temporaryValue, randomIndex;

	  // While there remain elements to shuffle...
	  while (0 !== currentIndex) {

	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;

	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }

	  return array;
	}



</script>

<div class="app-container">
	<main class="main">
		{#if !loading}
			{#if !done}
			<Covers covers={covers} on:message={messageHandler}/>
			{:else}
				<Recommendations {recommendations}/>
			{/if}
		{:else}
			<Loading />
		{/if}
		
	</main>
	<div class="nav"><Navigation on:message={messageHandler} /></div>
	
</div>

<style>
	.main {
		padding: 0 0.5rem;
		width: 100%;
		max-width: 600px;
		margin: 0 auto;
		height: 100%;
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}

	.app-container {
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: space-between;
		flex-grow: 1;
		align-items: center;
	}

	.nav {
		position: fixed;
		bottom: 0;
		width: 100%;
	}

	@media screen and (min-width:720px) {
		.main {
			max-width: 900px;
		}
	}


</style>
